export default class WaitTimeHelper {
    constructor({ model, isVisitor = false }) {
        this.model = model;
        this.isVisitor = isVisitor;

        this.MAX_WAIT_MONTHS_TO_SHOW = 6;
        this.MAX_WAIT_WEEKS_TO_SHOW = 26;
    }

    waitTimeHtml() {
        let html = '';
        if (!this.hideWaitTime()) {
            html = `${window.text(
                'expectedWaitTime.waitTime'
            )}: ${this.waitTimeText()}`;
        }
        return html;
    }

    waitTimeText() {
        let waitTimeText = '';
        const estimatedWaitDays = this.estimatedWaitDays();

        if (!this.hideWaitTime()) {
            if (this.showWaitTimeUnavailable()) {
                waitTimeText = text('expectedWaitTime.notAvailable');
            } else {
                if (estimatedWaitDays <= 7) {
                    waitTimeText = text('expectedWaitTime.availableSoon');
                } else if (
                    estimatedWaitDays <
                    7 * this.MAX_WAIT_WEEKS_TO_SHOW
                ) {
                    waitTimeText = text('expectedWaitTime.aboutXWeeks', {
                        weeks: Math.ceil(estimatedWaitDays / 7),
                    });
                } else {
                    // we intentionally max out at "at least 6 months"
                    waitTimeText = text('expectedWaitTime.atLeastYMonths', {
                        months: Math.min(
                            Math.ceil(estimatedWaitDays / 30),
                            this.MAX_WAIT_MONTHS_TO_SHOW
                        ),
                    });
                }
            }
        }

        return waitTimeText;
    }

    estimatedWaitDays() {
        return Number(this.model.get('estimatedWaitDays'));
    }

    showWaitTimeUnavailable() {
        return (
            this.estimatedWaitDays() === undefined ||
            this.estimatedWaitDays() === null ||
            this.isVisitor ||
            this.model.isExpired ||
            (this.model.get('isPreReleaseTitle') && !this.titleOnHold())
        );
    }

    hideWaitTime() {
        return (
            this.model.get('isFastlane') ||
            this.titleBorrowed() ||
            (!this.model.get('isPreReleaseTitle') && this.titleOnHold())
        );
    }

    titleOnHold() {
        return window.featureManager.isEnabled('betterPatronState')
            ? this.model.get('isOnHold')
            : this.model.get('titleState') === 'onHold';
    }

    titleBorrowed() {
        return window.featureManager.isEnabled('betterPatronState')
            ? this.model.get('isBorrowed')
            : this.model.get('titleState') === 'borrowed';
    }
}
